jQuery(function ($) {
  const $scrollCtrl = $('#scroll-to-top');

  $scrollCtrl.on('click', function (e) {
    e.preventDefault();

    window.scroll({top: 0, left: 0, behavior: 'smooth'});
  });

  $(window).on('scroll resize', function () {
    let scrollTop = document.querySelector('html').scrollTop,
        windowHeight = $(window).height(),
        showOnScrollMobile = windowHeight;

    if ($(window).width() > 700 && (scrollTop - windowHeight) > 0) {
      //desktop
      $scrollCtrl.addClass('active');
    } else if ($(window).width() <= 700 && (showOnScrollMobile - scrollTop) < 150) {
      //mobile
      $scrollCtrl.addClass('active');
    } else {
      $scrollCtrl.removeClass('active');
    }
  });
});
